/* eslint-disable @next/next/no-img-element */
import React from 'react';
import RedButton from '../../atoms/RedButton';
import Style from './ArticleCTA.css';

function ArticleCTA({
  cta: { description, text, url, icon, descriptionIcon },
  enableButton,
  disableText,
}) {
  return (
    <>
      <div className="cta-card">
        {!disableText && (
          <>
            {icon && (
              <div className="cta-icon">
                <img src={icon} alt="" width="32" height="32" />
              </div>
            )}

            <h3>
              {description}
              {descriptionIcon && (
                <>
                  &nbsp;
                  <img
                    className="cta-desc-icon"
                    src={descriptionIcon}
                    alt=""
                    width="16"
                    height="16"
                  />
                </>
              )}
            </h3>
          </>
        )}
        <RedButton
          href={url}
          target="_blank"
          rel="noopener"
          className={enableButton ? 'cta-btn-enabled' : 'cta-btn-disabled'}
        >
          {text}
        </RedButton>
      </div>
      <style jsx>{Style}</style>
    </>
  );
}

ArticleCTA.defaultProps = {
  enableButton: true,
  disableText: false,
};

export default ArticleCTA;
